import { CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	amount: 'amount',
	unlockedCoins: 'unlockedCoins',
	tickets: 'tickets',
	bonusCoins: 'bonusCoins',
	actualCoins: 'actualCoins',
	addedCoins: 'addedCoins',
	cashbackCoins: 'cashbackCoins'
};
export const conversionsConfig = [
	CategoricalColumn({
		title: 'Amount',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.amount] || ''
	}),
	CategoricalColumn({
		title: 'Bonus Money',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.unlockedCoins] || ''
	}),
	CategoricalColumn({
		title: 'Tickets',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.tickets] || ''
	}),
	CategoricalColumn({
		title: 'Bonus Coins',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.bonusCoins] || ''
	}),
	CategoricalColumn({
		title: 'Winnings',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.actualCoins] || ''
	}),
	CategoricalColumn({
		title: 'Play Money',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.addedCoins] || ''
	}),
	CategoricalColumn({
		title: 'Cashback Money',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackCoins] || ''
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 0,
		pageSize: 100
	},
	sortDetails: {
		sortField: 'code',
		sortOrder: 'ASC'
	}
};
